/**
 * Helpers centralizados para mostrar fechas en horario local de Guadalajara
 * (America/Mexico_City, GMT-6 sin DST). Úsalos en lugar de llamar
 * `toLocaleDateString`/`toLocaleString` directo: garantiza que toda la
 * app muestre la misma hora aunque el navegador esté en otro huso.
 */
export const LOCAL_TZ = 'America/Mexico_City';

const fmtOpts = (base = {}) => ({ timeZone: LOCAL_TZ, ...base });

export const formatDate = (iso, opts = {}) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('es-MX', fmtOpts(opts));
    } catch {
        return String(iso);
    }
};

export const formatTime = (iso, opts = { hour: '2-digit', minute: '2-digit' }) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleTimeString('es-MX', fmtOpts(opts));
    } catch {
        return '';
    }
};

export const formatDateTime = (iso, opts = { dateStyle: 'short', timeStyle: 'short' }) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleString('es-MX', fmtOpts(opts));
    } catch {
        return String(iso);
    }
};

// YYYY-MM-DD en GMT-6 — útil para agrupar/comparar por día local
export const localDateKey = (iso) => {
    if (!iso) return '';
    try {
        return new Date(iso).toLocaleDateString('en-CA', fmtOpts());
    } catch {
        return (iso || '').slice(0, 10);
    }
};

// Etiqueta tipo "lunes 14 de febrero" (en GMT-6)
export const formatDayLabel = (isoOrYmd) => {
    if (!isoOrYmd) return '';
    let d;
    if (/^\d{4}-\d{2}-\d{2}$/.test(isoOrYmd)) {
        const [y, m, day] = isoOrYmd.split('-').map(Number);
        d = new Date(y, m - 1, day);
        // local Date: format without timezone option (already local-aware)
        return d.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' });
    }
    return new Date(isoOrYmd).toLocaleDateString('es-MX', fmtOpts({ weekday: 'long', day: 'numeric', month: 'long' }));
};

// Hoy en GMT-6 como YYYY-MM-DD
export const localTodayKey = () => localDateKey(new Date().toISOString());

// Primer día del mes actual en GMT-6 como YYYY-MM-DD
export const localMonthStartKey = () => `${localTodayKey().slice(0, 7)}-01`;
